import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { houseSettingsActions } from "../../redux/houseSettingsSlice";
import { notification, Switch } from "antd";

const AddHouseSettingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isBulkMode, setIsBulkMode] = useState(false); // Toggle between single and bulk modes
  const [houseNumber, setHouseNumber] = useState(""); // For single entry
  const [bulkHouseNumbers, setBulkHouseNumbers] = useState(""); // For bulk entry
  const [loading, setLoading] = useState(false); // Handle loading state

  // Handle single house addition
  const handleAddHouseSetting = (e) => {
    e.preventDefault();
    setLoading(true);

    const newHouseSetting = { house_number: houseNumber };

    dispatch(houseSettingsActions.addHouseSetting(newHouseSetting))
      .unwrap()
      .then(() => {
        notification.success({
          message: "Success",
          description: "House setting added successfully",
        });
        setHouseNumber("");
        navigate("/dashboard/houseSettings");
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description:
            JSON.stringify(err.errors) || "Failed to add house setting",
        });
      })
      .finally(() => setLoading(false));
  };

  // Handle bulk house addition
  const handleBulkAddHouseSettings = (e) => {
    e.preventDefault();
    setLoading(true);
    const bulkHouseSetting = { number_of_houses: bulkHouseNumbers };

    const houseNumbers = bulkHouseNumbers
      .split("\n")
      .map((num) => num.trim())
      .filter((num) => num !== "");

    if (houseNumbers.length === 0) {
      notification.error({
        message: "Error",
        description: "No valid house numbers entered",
      });
      setLoading(false);
      return;
    }

    dispatch(houseSettingsActions.addBulkHouseSetting(bulkHouseSetting))
      .unwrap()
      .then(() => {
        notification.success({
          message: "Success",
          description: `${houseNumbers.length} house settings added successfully`,
        });
        setBulkHouseNumbers("");
        navigate("/dashboard/houseSettings");
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description:
            JSON.stringify(err.errors) || "Failed to add house settings",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="add-house-setting-page p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Add House Settings</h2>
        <Switch
          checked={isBulkMode}
          onChange={(checked) => setIsBulkMode(checked)}
          checkedChildren="Bulk House entry"
          unCheckedChildren="Single House Entry"
        />
      </div>

      {isBulkMode ? (
        <form
          onSubmit={handleBulkAddHouseSettings}
          className="flex flex-col gap-4 mt-8"
        >
          <div>
            <label className="font-bold text-md">Bulk House Numbers</label>
            <input
              className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2"
              value={bulkHouseNumbers}
              onChange={(e) => setBulkHouseNumbers(e.target.value)}
              placeholder="Enter one house number per line"
              required
            ></input>
          </div>
          <button
            type="submit"
            className={`bg-[#403F93] text-white flex px-24 py-3 rounded-md mt-6 ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add House Settings"}
          </button>
        </form>
      ) : (
        <form
          onSubmit={handleAddHouseSetting}
          className="flex flex-col gap-4 mt-8"
        >
          <div>
            <label className="font-bold text-md">House Number</label>
            <input
              className="rounded-md py-3 px-4 w-full border-[2px] border-gray-400 mt-2"
              type="text"
              value={houseNumber}
              onChange={(e) => setHouseNumber(e.target.value)}
              placeholder="Enter house number"
              required
            />
          </div>
          <button
            type="submit"
            className={`bg-[#403F93] text-white flex px-24 py-3 rounded-md mt-6 ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add New House Setting"}
          </button>
        </form>
      )}
    </div>
  );
};

export default AddHouseSettingPage;
